import { AuthService } from '../../auth/auth.service';
import { LanguageService } from '../../shared/services/language.service';
import { DashboardInfoService } from './dashboard-info.service';

import { DatexPipe } from '../../shared/datex.pipe';

import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  inject,
  Injector,
  input,
  OnInit,
  signal,
  untracked,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { ApiInfoMessage } from './models/api-info-message.interface';
import { catchError, firstValueFrom, of } from 'rxjs';
import { isNil } from 'src/utils/utils';

export const MODULES = [
  CommonModule,
  MatCardModule,
  MatIconModule,
  MatButtonModule,
];
export const COMPONENTS = [FaIconComponent];

@Component({
  selector: 'app-dashboard-info',
  templateUrl: './dashboard-info.component.html',
  styleUrls: ['./dashboard-info.component.scss', '../dashboard.component.scss'],
  imports: [...MODULES, ...COMPONENTS, DatexPipe],
})
export class DashboardInfoComponent implements OnInit {
  private injector = inject(Injector);
  private infoService = inject(DashboardInfoService);
  private auth = inject(AuthService);
  public languageService = inject(LanguageService);

  refresh = input<number>();

  previousRefresh = signal(null);
  showInfo = signal(false);
  data: ApiInfoMessage;
  textParagraphs = signal([]);
  classToApply = signal<string>(undefined);
  iconToUse = signal<IconProp>(undefined);

  infoCfg = {
    0: {
      class: 'info-primary',
      icon: ['far', 'info-circle'],
    },
    1: {
      class: 'info-warning',
      icon: ['far', 'exclamation-triangle'],
    },
    2: {
      class: 'info-danger',
      icon: ['far', 'exclamation-triangle'],
    },
  };

  constructor() {
    this.refreshInfoData();
  }

  ngOnInit(): void {
    this.checkData();
  }

  async checkData(): Promise<void> {
    const cardSetToClosed = localStorage.getItem('infoCard');

    // 1. Sicherer Abruf (liefert null statt zu crashen)
    this.data = await this.onGetData();

    // 2. Prüfen, ob überhaupt Daten da sind
    if (!this.data) {
      this.showInfo.set(false);
      return;
    }

    this.showInfo.set(
      this.checkIfInfoCardShouldBeShown(this.data, cardSetToClosed)
    );

    if (this.showInfo() && this.infoCfg[this.data.status]) {
      const cfg = this.infoCfg[this.data.status];
      this.classToApply.set(cfg.class);
      this.iconToUse.set(cfg.icon);
      const text = this.data.text || '';
      this.textParagraphs.set(text.split('\n'));
    }
  }

  onGetData(): Promise<ApiInfoMessage | null> {
    const customerId = this.auth.getCustomerDocument()?.customerId;
    return firstValueFrom(
      this.infoService.getInfoMessage(customerId).pipe(
        catchError(err => {
          console.error('Info-Service Fehler:', err);
          return of(null);
        })
      )
    );
  }

  /*async checkData(): Promise<void> {
  const cardSetToClosed = localStorage.getItem('infoCard');
  this.data = await this.onGetData();

  this.showInfo.set(
    this.checkIfInfoCardShouldBeShown(this.data, cardSetToClosed)
  );

  if (this.showInfo()) {
    this.classToApply.set(this.infoCfg[this.data.status].class);
    this.iconToUse.set(this.infoCfg[this.data.status].icon);
    this.textParagraphs.set([...this.data.text.split('\n')]);
  }
}

// TODO: Wiederholung der Abfrage ob eine neue information da ist. Wie oft soll das passieren?
onGetData(): Promise<ApiInfoMessage> {
  const customerDocument = this.auth.getCustomerDocument();

  return new Promise((resolve, reject) => {
    this.infoService.getInfoMessage(customerDocument?.customerId).subscribe(
      data => {
        resolve(data);
      },
      err => reject(err)
    );
  });
}*/

  onCloseInfo(): void {
    this.showInfo.set(false);
    localStorage.setItem('infoCard', this.data.writtenAt);
  }

  checkIfInfoCardShouldBeShown(
    data: ApiInfoMessage,
    cardSetToClosed: string | null
  ): boolean {
    if (
      data.id !== 0 &&
      data.active === 1 &&
      cardSetToClosed !== this.data.writtenAt &&
      !this.auth.isZuerichCustomer()
    ) {
      return true;
    }
  }

  private refreshInfoData() {
    effect(
      () => {
        const refresh = this.refresh();
        untracked(() => {
          const previousRefresh = this.previousRefresh();
          if (!isNil(previousRefresh) && refresh > previousRefresh) {
            if (refresh > 1) {
              this.checkData();
            }
          }
          this.previousRefresh.set(refresh);
        });
      },
      { injector: this.injector }
    );
  }
}
